import { IonLoading } from '@ionic/react';
import React, { Fragment } from 'react';
import { withConversation } from '../../hoc';
import { Character, Message, MessageType } from '../../models';
import { Chat } from './Chat';
import { ChatHeader } from './ChatHeader';

interface Props {
  character: Character | null;
  discussion: Message[];
  loading: boolean;
  send: (
    conversation: string,
    message: string,
    type?: MessageType,
    author?: string,
  ) => void;
}

const ConversationContentView: React.FC<Props> = ({
  character,
  discussion,
  loading,
  send,
}) => {
  if (loading) {
    return (
      <IonLoading
        isOpen={true}
        message="Let us connect together in some seconds, please wait."
      />
    );
  }

  return (
    <Fragment>
      <ChatHeader send={send} character={character} />
      <Chat discussion={discussion} send={send} />
    </Fragment>
  );
};

export const ConversationContent = withConversation(ConversationContentView);
